/**
 * CLX information — promo card carousel behavior.
 * Externalized from sections/clx-information.liquid.
 *
 * - Tap-to-copy promo code chips with a temporary "Copied" state.
 * - Live countdown chips ("Ends in 2d 5h"), hidden once expired or when
 *   the date can't be parsed; refreshed every minute.
 * - Staggered card reveal on scroll. Cards are pre-marked hidden by a
 *   tiny pre-paint stub inline in the section (so cards already painted
 *   don't blink); this module re-marks them anyway so it also works
 *   standalone, then reveals them as they intersect.
 * All motion respects prefers-reduced-motion.
 */
function initInformation(root) {
  if (!root || root.dataset.clxInit) return;
  root.dataset.clxInit = '1';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* tap-to-copy promo codes */
  root.addEventListener('click', (event) => {
    const chip = event.target.closest('.ix-info-card__code');
    if (!chip || chip.classList.contains('is-copied')) return;
    const done = () => {
      chip.classList.add('is-copied');
      setTimeout(() => {
        chip.classList.remove('is-copied');
      }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(chip.getAttribute('data-code') || '').then(done, done);
    } else {
      done();
    }
  });

  /* live countdown chips */
  const timers = Array.from(root.querySelectorAll('[data-ends]'));
  if (timers.length) {
    const tick = () => {
      const now = Date.now();
      timers.forEach((el) => {
        const ends = Date.parse(el.getAttribute('data-ends'));
        const out = el.querySelector('[data-timer-text]');
        if (!out || isNaN(ends) || ends <= now) {
          el.hidden = true;
          return;
        }
        const minutes = Math.floor((ends - now) / 60000);
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor((minutes % 1440) / 60);
        const mins = minutes % 60;
        out.textContent =
          'Ends in ' + (days > 0 ? days + 'd ' + hours + 'h' : hours > 0 ? hours + 'h ' + mins + 'm' : mins + 'm');
        el.hidden = false;
      });
    };
    tick();
    setInterval(tick, 60000);
  }

  /* staggered reveal on scroll */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const cards = root.querySelectorAll('.ix-info-card');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
    );
    cards.forEach((card, index) => {
      card.classList.add('is-reveal');
      card.style.setProperty('--clx-i', index % 6);
      io.observe(card);
    });
  }
}

document.querySelectorAll('.ix-information').forEach(initInformation);

/* theme editor: init sections re-rendered after a settings change */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.ix-information').forEach(initInformation);
});
